/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import {
  roleMappingManage,
  roleMappingView,
  globalConfigCreate,
  globalConfigDelete,
  globalConfigManage,
  globalConfigUpdate,
  globalConfigView,
  configCreate,
  configDelete,
  configManage,
  configView,
  onPremKeyView,
  onPremKeyManage,
  onPremKeyCreate,
  onPremKeyDelete,
  onPremKeyUpdate,
  roleCreate,
  roleUpdate,
  roleDelete,
  roleManage,
  roleView,
  themeView,
  themeDeploy,
  themeDelete,
  themeCreate,
  themeManage,
  selfSignupApprovalUpdate,
  selfSignupApprovalView,
  selfSignupConfigUpdate,
  selfSignupConfigView,
  selfSignupManage,
  enterpriseLoginConfigView,
  enterpriseLoginManage,
  userManage,
  userView,
  userDelete,
  userUpdate,
  permissionView,
  invitationDelete,
  invitationManage,
  invitationSend,
  invitationView,
  roleMappingCreate,
  roleMappingDelete,
  roleMappingUpdate,
  componentManage,
  componentConfigView,
  componentCreate,
  componentFileView,
  componentInitView,
  componentLogsView,
  componentTrigger,
  auditLogsView,
  auditLogsManage,
  choreoOrgManage,
} from 'config';
/*
  TODO : Need to sync with teams and update all the permissions here
  Following are the currently identified permissions
*/
export default class AccessControlConstants {
  private constructor() {}

  // Platform Engineer Scope
  public static readonly PLATFORM_ENGINEER_VIEW: string =
    'choreo:platform_engineer';

  // APIM publisher
  public static readonly APIM_API_VIEW: string = 'apim:api_view';

  public static readonly APIM_API_IMPORT_EXPORT: string =
    'apim:api_import_export';

  public static readonly APIM_API_CREATE: string = 'apim:api_create';

  public static readonly APIM_API_PRODUCT_IMPORT_EXPORT: string =
    'apim:api_product_import_export';

  public static readonly APIM_API_PUBLISH: string = 'apim:api_publish';

  public static readonly APIM_API_DELETE: string = 'apim:api_delete';

  public static readonly APIM_API_MANAGE: string = 'apim:api_manage';

  public static readonly APIM_API_PUBLISHER_SETTINGS: string =
    'apim:publisher_settings';

  public static readonly APIM_API_DOCUMENT_CREATE: string =
    'apim:document_create';

  public static readonly APIM_API_SETTINGS: string = 'apim:api_settings';

  public static readonly APIM_API_DOCUMENT_MANAGE: string =
    'apim:document_manage';

  public static readonly APIM_API_GENERATE_KEY: string =
    'apim:api_generate_key';

  public static readonly APIM_SUBSCRIPTION_MANAGE: string =
    'apim:subscription_manage';

  public static readonly APIM_SUBSCRIPTION_VIEW: string =
    'apim:subscription_view';

  public static readonly APIM_SUBSCRIPTION_BLOCK: string =
    'apim:subscription_block';

  public static readonly APIM_TIER_MANAGE: string = 'apim:tier_manage';

  public static readonly APIM_TIER_VIEW: string = 'apim:tier_view';

  // APIM devportal
  public static readonly APIM_SUBSCRIBE: string = 'apim:subscribe';

  public static readonly APIM_SUB_MANAGE: string = 'apim:sub_manage';

  public static readonly APIM_APP_MANAGE: string = 'apim:app_manage';

  public static readonly APIM_APP_IMPORT_EXPORT: string =
    'apim:app_import_export';

  public static readonly APIM_API_KEY: string = 'apim:api_key';

  // APIM admin
  public static readonly APIM_ADMIN: string = 'apim:admin';

  public static readonly APIM_ADMIN_OPERATIONS: string =
    'apim:admin_operations';

  public static readonly APIM_ENV_MANAGE: string = 'apim:environment_manage';

  // Billing and subscription
  public static readonly BILLING_TIER_VIEW: string = 'billing:tier_view';

  public static readonly BILLING_ORG_CREATE: string = 'billing:org_create';

  public static readonly BILLING_ORG_VIEW: string = 'billing:org_view';

  public static readonly BILLING_INVOICE_VIEW: string = 'billing:invoice_view';

  public static readonly BILLING_SUBSCRIPTION_CREATE: string =
    'billing:subscription_create';

  public static readonly BILLING_SUBSCRIPTION_VIEW: string =
    'billing:subscription_view';

  public static readonly BILLING_PAYMENT_METHOD_CREATE: string =
    'billing:payment_method_create';

  public static readonly BILLING_PAYMENT_METHOD_VIEW: string =
    'billing:payment_method_view';

  // Choreo user mgt
  public static readonly CHOREO_USER_MANAGE: string = userManage;

  public static readonly CHOREO_ORGANIZATION_MANAGE: string =
    'choreo:organization_manage';

  public static readonly USERS_MGT_ROLE_MAPPING_VIEW: string = roleMappingView;

  public static readonly USERS_MGT_ROLE_MAPPING_CREATE: string =
    roleMappingCreate;

  public static readonly USERS_MGT_ROLE_MAPPING_UPDATE: string =
    roleMappingUpdate;

  public static readonly USERS_MGT_ROLE_MAPPING_DELETE: string =
    roleMappingDelete;

  public static readonly USERS_MGT_ROLE_MAPPING_MANAGE: string =
    roleMappingManage;

  public static readonly USERS_MGT_ROLE_VIEW: string = roleView;

  public static readonly USERS_MGT_ROLE_CREATE: string = roleCreate;

  public static readonly USERS_MGT_ROLE_UPDATE: string = roleUpdate;

  public static readonly USERS_MGT_ROLE_DELETE: string = roleDelete;

  public static readonly USERS_MGT_ROLE_MANAGE: string = roleManage;

  public static readonly USERS_MGT_USER_MANAGE: string = userManage;

  public static readonly USERS_MGT_USER_VIEW: string = userView;

  public static readonly USERS_MGT_USER_DELETE: string = userDelete;

  public static readonly USERS_MGT_USER_UPDATE: string = userUpdate;

  public static readonly USERS_MGT_PERMISSION_VIEW: string = permissionView;

  public static readonly USERS_MGT_INVITATION_MANAGE: string = invitationManage;

  public static readonly USERS_MGT_INVITATION_SEND: string = invitationSend;

  public static readonly USERS_MGT_INVITATION_DELETE: string = invitationDelete;

  public static readonly USERS_MGT_INVITATION_VIEW: string = invitationView;

  public static readonly COMPONENT_TRIGGER: string = componentTrigger;

  public static readonly COMPONENT_CREATE: string = componentCreate;

  public static readonly COMPONENT_CONFIG_VIEW: string = componentConfigView;

  public static readonly COMPONENT_LOGS_VIEW: string = componentLogsView;

  public static readonly COMPONENT_INIT_VIEW: string = componentInitView;

  public static readonly COMPONENT_FILE_VIEW: string = componentFileView;

  public static readonly COMPONENT_MANAGE: string = componentManage;

  public static readonly GLOBAL_CONFIG_MGT_ROLE_MAPPING_VIEW: string =
    globalConfigView;

  public static readonly GLOBAL_CONFIG_MGT_ROLE_MAPPING_DELETE: string =
    globalConfigDelete;

  public static readonly GLOBAL_CONFIG_MGT_ROLE_MAPPING_CREATE: string =
    globalConfigCreate;

  public static readonly GLOBAL_CONFIG_MGT_ROLE_MAPPING_UPDATE: string =
    globalConfigUpdate;

  public static readonly GLOBAL_CONFIG_MGT_ROLE_MAPPING_MANAGE: string =
    globalConfigManage;

  public static readonly CHOREO_DEPLOYMENT_MANAGE: string =
    'choreo:deployment_manage';

  public static readonly CHOREO_PROJECT_MANAGE: string =
    'choreo:project_manage';

  public static readonly CHOREO_COMPONENT_MANAGE: string =
    'choreo:component_manage';

  public static readonly CHOREO_WORKFLOW_COMPONENT_PROMOTION_APPROVE: string =
    'choreo:workflow_component_promotion_approve';

  public static readonly CHOREO_WORKFLOW_SUBSCRIPTION_APPROVE: string =
    'choreo:workflow_subscription_approve';

  public static readonly CHOREO_WORKFLOW_URL_MAPPING_APPROVE: string =
    'choreo:workflow_url_mapping_approve';

  public static readonly CHOREO_WORKFLOW_REQUEST: string =
    'choreo:workflow_request';

  public static readonly CHOREO_NON_PROD_ENV_MANAGE: string =
    'choreo:non_prod_env_manage';

  public static readonly CHOREO_PROD_ENV_MANAGE: string =
    'choreo:prod_env_manage';

  public static readonly CHOREO_ENV_MANAGE: string = 'choreo:env_manage';

  public static readonly CHOREO_LOG_VIEW_NON_PROD_MANAGE: string =
    'choreo:log_view_non_prod';

  public static readonly CHOREO_LOG_VIEW_PROD_MANAGE: string =
    'choreo:log_view_prod';

  public static readonly CHOREO_LOG_VIEW: string = 'choreo:log_view';

  public static readonly CONFIG_MGT_VIEW: string = configView;

  public static readonly CONFIG_MGT_DELETE: string = configDelete;

  public static readonly CONFIG_MGT_CREATE: string = configCreate;

  public static readonly CONFIG_MGT_MANAGE: string = configManage;

  public static readonly THEME_VIEW: string = themeView;

  public static readonly THEME_DELETE: string = themeDelete;

  public static readonly THEME_CREATE: string = themeCreate;

  public static readonly THEME_MANAGE: string = themeManage;

  public static readonly THEME_DEPLOY: string = themeDeploy;

  public static readonly SELF_SIGNUP_CONFIG_VIEW: string = selfSignupConfigView;

  public static readonly SELF_SIGNUP_CONFIG_UPDATE: string =
    selfSignupConfigUpdate;

  public static readonly SELF_SIGNUP_APPROVAL_VIEW: string =
    selfSignupApprovalView;

  public static readonly SELF_SIGNUP_APPROVAL_UPDATE: string =
    selfSignupApprovalUpdate;

  public static readonly SELF_SIGNUP_MANAGE: string = selfSignupManage;

  public static readonly ENTERPRISE_LOGIN_CONFIG_VIEW: string =
    enterpriseLoginConfigView;

  public static readonly ENTERPRISE_LOGIN_MANAGE: string =
    enterpriseLoginManage;

  public static readonly CUSTOM_DOMAIN_VIEW: string = 'choreo:domain_view';

  public static readonly CUSTOM_DOMAIN_MANAGE: string = 'choreo:domain_manage';

  public static readonly URL_MAPPING_VIEW: string = 'choreo:url_mapping_view';

  public static readonly URL_MAPPING_APPROVE: string =
    'choreo:url_mapping_approve';

  public static readonly URL_MAPPING_MANAGE: string =
    'choreo:url_mapping_manage';

  public static readonly ON_PREM_KEY_VIEW: string = onPremKeyView;

  public static readonly ON_PREM_KEY_MANAGE: string = onPremKeyManage;

  public static readonly ON_PREM_KEY_CREATE: string = onPremKeyCreate;

  public static readonly ON_PREM_KEY_DELETE: string = onPremKeyDelete;

  public static readonly ON_PREM_KEY_UPDATE: string = onPremKeyUpdate;

  // Audit Logs
  public static readonly AUDIT_LOGS_VIEW: string = auditLogsView;

  public static readonly AUDIT_LOGS_MANAGE: string = auditLogsManage;

  public static readonly CHOREO_ORG_MANAGE: string = choreoOrgManage;

  // DevOps Portal
  public static readonly DEVOPS_PORTAL_DEPLOYMENT_VIEW: string =
    'urn:choreocontrolplane:choreodevopsportalapi:deployment_view';

  public static readonly DEVOPS_PORTAL_DEPLOYMENT_MANAGE: string =
    'urn:choreocontrolplane:choreodevopsportalapi:deployment_manage';

  public static readonly CHOREOSYSTEM_DEVOPS_PORTAL_DEPLOYMENT_VIEW: string =
    'urn:choreosystem:choreodevopsportalapi:deployment_view';

  public static readonly CHOREOSYSTEM_DEVOPS_PORTAL_DEPLOYMENT_MANAGE: string =
    'urn:choreosystem:choreodevopsportalapi:deployment_manage';

  // DevOps
  public static readonly DEVOPS_DEPLOYMENT_VIEW: string =
    'devops:deployment:read';

  public static readonly DEVOPS_DEPLOYMENT_MANAGE: string = 'devops:deployment';
}
